
import { Component, Vue } from 'vue-property-decorator';
import JobbookingCreateForm from '@/components/forms/JobbookingCreateForm.vue';

@Component({
  components: {
    JobbookingCreateForm,
  },
})
export default class NewJobbookingView extends Vue {}
